/**
 * Favorites Route (Dynamic Module)
 * Handles both /pc/favorites and /eb/favorites via :module param
 *
 * Authentication is handled by the parent _protected layout route.
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/$module/favorites')({
  // No beforeLoad - parent _protected handles auth
});
